<template>
  <section class="finish" dusk="registration-completed">
    <v-style id="styles">
      :root {
      --profile-photo: url({{photoUrl}})  left no-repeat;
      }
    </v-style>
            <div class="inner">
                   <div class="headline">
                     {{trans('welcome.what_next')}}
                   </div>
                  <div class="onboard-choice">
                    <div @click="goTo(isMobile ? '/profile/edit' : '/discover?show_edit_profile=true')" class="item">
                      <div class="info">
                        <div class="name">
                          {{profile.headline}}
                        </div>
                        <div class="text-mute">
                          {{trans('welcome.nickname_description')}}
                        </div>
                      </div>
                    </div>
                    <div @click="goTo('/discover')" class="item">
                      <div class="info">
                        <div class="name">
                          {{trans("welcome.discover")}}
                        </div><!--
                        <div class="text-mute">
                          {{trans("welcome.discover_description")}}
                        </div>-->
                      </div>
                    </div>
                    <div @click="goTo('/profile/pro')" class="item">
                      <div class="info">
                        <div class="name">
                          {{trans("welcome.pro")}}
                        </div><!--
                        <div class="text-mute">
                          {{trans("welcome.pro_description")}}
                        </div>-->
                      </div>
                    </div>
                  </div>
            </div>
        </section>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        mixins: [require('@general/lib/mixin').default],
        methods: {
          goTo: function (path){
           window.location = path;
          }
        },
        computed: {
            ...mapState([
                'profile'
            ]),
            photoUrl(){
                return this.profile.photo_small
            }
        },
        mounted() {
            //fbq('track', 'CompleteRegistration');
        }
    }
</script>
